module.exports = __webpack_public_path__ + "img/option3.659e8b59.png";